import { IControlOption } from '@/Interfaces/ControlOption.interface';
import { Autocomplete, AutocompleteChangeReason, TextField } from '@mui/material';
import { Control, Controller } from 'react-hook-form';

interface IProps<ControlOption> {
  options: ControlOption[] | IControlOption[];
  shouldUnregister?: boolean;
  control: Control;
  name: string;
  id: string;
  placeholder: string;
  disabled?: boolean;
  required?: boolean;
  multiple?: boolean;
  onChangeListener?: (reason: AutocompleteChangeReason, value?: ControlOption) => void;
}

function AutocompleteControl<ControlOption>({
  control,
  shouldUnregister,
  options,
  name,
  id,
  placeholder,
  disabled,
  required = false,
  multiple = false,
  onChangeListener,
}: IProps<ControlOption>) {
  return (
    <Controller
      name={name}
      rules={{
        required: {
          value: required,
          message: 'Please select an option.',
        },
      }}
      control={control}
      shouldUnregister={shouldUnregister}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          {...field}
          id={id}
          options={options}
          fullWidth
          disabled={disabled}
          onChange={(_, data, reason, detail) => {
            if (onChangeListener) {
              onChangeListener(reason, detail?.option);
            }
            field.onChange(data);
          }}
          getOptionLabel={option => option?.label || ''}
          disableClearable={required}
          isOptionEqualToValue={(option, selectValue) => selectValue && option.value === selectValue?.value}
          getOptionKey={option => option.value}
          multiple={multiple}
          renderInput={params => (
            <TextField
              {...params}
              placeholder={placeholder}
              variant='outlined'
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      )}
    />
  );
}

export default AutocompleteControl;
